import { render, staticRenderFns } from "./UploadRecordedLectureModal.vue?vue&type=template&id=f0041d24&"
import script from "./UploadRecordedLectureModal.vue?vue&type=script&lang=js&"
export * from "./UploadRecordedLectureModal.vue?vue&type=script&lang=js&"
import style0 from "./UploadRecordedLectureModal.vue?vue&type=style&index=0&id=f0041d24&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../Github/lmsv4_web_frontend_vue/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports